import { LEVEL } from './LEVEL';
import { APP_START_TIME } from './index';
import { NikeLog } from '../../types/generated/nike-log';

export interface BaseLogArgs extends NikeLog.ClientLog {
    category: string;
    message: string;
    data: Record<any, any>;
    stacktrace?: string;
    level: LEVEL;
}

export function BaseLog({
    category,
    message = '',
    data = {},
    stacktrace = '',
    level = LEVEL.WARN
}: Partial<NikeLog.ClientLog>) {
    if (!category) {
        throw Error('Log: field category is mandatory');
    }

    if (!(typeof data === 'object')) {
        throw Error('Log: field data has invalid type');
    }

    return {
        category,
        message,
        data,
        stacktrace,
        level,
        clientTimestamp: Date.now(),
        app_version: (window as any).OPTIONS.version,
        app_start_time: APP_START_TIME
    };
}
